<template>
  <div class="mt-2">
    <div class="text-center">
      <img src="/logo.png" width="200">
    </div>
  </div>
</template>
